import React, { useState, useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Option from './TypeaheadOption';
import prepareHybridPlaces from './prepareHybridPlaces';

const TypeaheadOptionsContainer = ({ showItems, setShowItems, terminalPlacesOnly, url }) => {
  const [places, setPlaces] = useState([]);

  const fetchPlaces = useCallback(() => {
    if (url !== '') {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          setShowItems(true);
          setPlaces(data);
        });
    }
  }, [setShowItems, url]);

  useEffect(() => {
    fetchPlaces();
  }, [fetchPlaces]);

  const options = useMemo(
    () => prepareHybridPlaces(places, { terminalPlacesOnly }),
    [places, terminalPlacesOnly],
  );

  return (
    <ul
      className="typeahead"
      style={{
        display: showItems ? 'block' : 'none',
      }}
    >
      {options.length > 0 &&
        showItems &&
        options.map((option) => {
          return <Option key={option.slug} place={option} />;
        })}
    </ul>
  );
};

const propTypes = {
  terminalPlacesOnly: PropTypes.bool,
  url: PropTypes.string.isRequired,
  showItems: PropTypes.bool.isRequired,
  setShowItems: PropTypes.func.isRequired,
};

const defaultProps = {
  terminalPlacesOnly: false,
};

TypeaheadOptionsContainer.propTypes = propTypes;
TypeaheadOptionsContainer.defaultProps = defaultProps;
export default TypeaheadOptionsContainer;
